module.exports = __webpack_public_path__ + "img/image(1)-2.8c865f91.png";